import getToken from "./getToken";

const hasAIPermission = () => {
  const token = getToken();
  if (!token) return false;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const screensClaim = payload['Screens'];
    if (!screensClaim) return false;
    return screensClaim.includes('AI');
  } catch (error) {
    console.error('Error parsing token for AI permission:', error);
    return false;
  }
};

export default hasAIPermission;